import { createStore } from 'vuex'

//导入主题模式
import theme from './modules/theme.js'
import userStore from './modules/userStore.js'
import houseStore from './modules/houseStore.js'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    theme,
    userStore,
    houseStore
  }
})
